<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>

    <v-toolbar flat color="white">
      <v-toolbar-title>Agent Group</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Create</v-btn>
        </template>
        <v-card v-if="isAllowedNewAgentGroup()">
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm8 md8>
                  <v-text-field
                    v-model="editedItem.name"
                    label="Group Name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="editedItem.numbers_of_agent"
                    type="number"
                    label="Number of Agent"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else>
          <v-card-title>
            <span class="headline">Agent Group creation limit exceed</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <p>Please subscribe premium or corporate package</p>
                <br>
                <router-link to="/subscription-package"><p>click here to go to subscription page</p></router-link>                  
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.groups"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.code }}</td>
        <td class="text-xs-center">{{ props.item.numbers_of_agent }}</td>
        <td class="text-xs-center">{{ props.item.active_status }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import utilities from "../../api/utilities.js";
  export default {
    data: () => ({
      dialog: false,
      search: "",
      apiUrl: "agent-group",
      snackbar: false,
      y: "top",
      x: "right",
      timeout: 4000,
      headers: [
        { text: "id", align: "center", value: "id" },
        {
          text: "Group Name",
          align: "center",
          value: "name",
        },
        { text: "Code", align: "center", value: "code" },
        {
          text: "Number of Agent",
          align: "center",
          sortable: false,
          value: "numbers_of_agent",
        },
        {
          text: "Active Status",
          align: "center",
          value: "active_status",
        },
      ],
      editedIndex: -1,
      editedItem: {
        agent_group_name: "",
        numbers_of_agent: "",
      },
      defaultItem: {
        agent_group_name: "",
        numbers_of_agent: "",
      },
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "subscriptionData",
        "error",
        "statusCode",
        "errorMsg",
        "userImage",
        "docImage",
      ]),
      formTitle() {
        return this.editedIndex === -1 ? "Create New" : "Edit";
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.$store.dispatch("setIndexData", [this.apiUrl]);
      },

      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },

      editItem(item) {
        this.editedIndex = this.indexData.groups.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      deleteItem(item) {
        const index = this.indexData.groups.indexOf(item);
        confirm("Are you sure you want to delete this item?") &&
          this.indexData.groups.splice(index, 1);
        this.$store.dispatch("delete", [this.apiUrl, item.id]);
        this.snackbar = true;
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },
      isAllowedNewAgentGroup() {
      let allowedAgent = utilities.maximumNumberOfAgentGroup(this.subscriptionData.subscriptionFeatures);
      if (allowedAgent) {
        if (this.getIndexDataLength() < allowedAgent) {
          return true;
        }else{
          return false
        }
      }
    },

    getIndexDataLength(){
      if (this.indexData.groups) {
        return Object.keys(this.indexData.groups).length;
      }else{
        return 0;
      }
    },

      save() {
        // console.log([this.editedItem]);
        if (this.editedIndex > -1) {
          // console.log('success');
          this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
        } else {
          this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
        }
        this.snackbar = true;
        this.close();
      },
    },
  };
</script>
